import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function oneOfRequiredValidator(...fields: (string | string[])[]): ValidatorFn {
  const flatFields = fields.flat();

  return (control: AbstractControl): ValidationErrors | null => {
    if (!control || flatFields.length === 0) {
      return null;
    }

    const hasValue = flatFields.some((field) => {
      const childControl = control.get(field);
      if (!childControl) {
        return false;
      }

      const val = childControl.value;
      if (val === null || val === undefined || val === '') {
        return false;
      }

      if (Array.isArray(val) && val.length === 0) {
        return false;
      }

      return true;
    });

    return hasValue ? null : { oneOfRequired: true };
  };
}

export const OneOfRequired = oneOfRequiredValidator;
export const oneOfRequired = oneOfRequiredValidator;
